module.exports = __webpack_public_path__ + "static/media/copy-icon.3e9710d1.svg";